var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.933,17.732c-5.205-7.306-13.891-11.67-23.217-11.67c-7.124,0-14.053,2.583-19.708,7.222   C44.36,8.648,37.535,6.148,30.28,6.148c-9.351,0-18.031,4.349-23.236,11.659c-5.613,7.966-6.591,18.376-2.752,29.319   c7.489,21.333,35.95,41.686,41.583,45.552c1.229,0.838,2.657,1.26,4.084,1.26c1.415,0,2.825-0.411,4.051-1.246   c3.452-2.345,33.983-23.535,41.692-45.559C99.551,36.141,98.571,25.711,92.933,17.732z M31.426,52.931   c-4.104,0-7.43-3.327-7.43-7.431s3.327-7.43,7.43-7.43s7.43,3.327,7.43,7.43S35.53,52.931,31.426,52.931z M50,52.931   c-4.104,0-7.431-3.327-7.431-7.431s3.327-7.43,7.431-7.43c4.103,0,7.431,3.327,7.431,7.43S54.103,52.931,50,52.931z M68.573,52.931   c-4.103,0-7.43-3.327-7.43-7.431s3.327-7.43,7.43-7.43c4.104,0,7.431,3.327,7.431,7.43S72.677,52.931,68.573,52.931z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatient);
export default __webpack_public_path__ + "static/media/patient.198257607ef91c3c9f905918942c1f78.svg";
export { ForwardRef as ReactComponent };